import * as React from 'react';
import Animated, {
    interpolate,
    type SharedValue,
    useAnimatedStyle,
    withTiming,
} from 'react-native-reanimated';
import { XStack } from 'smoothie';

interface CardFlipProps {
    front: React.ReactNode;
    back: React.ReactNode;
    isFlipped: SharedValue<boolean>;
}

export const CardFlip = ({ front, back, isFlipped }: CardFlipProps) => {
    const duration = 750;

    const regularCardAnimatedStyle = useAnimatedStyle(() => {
        const spinValue = interpolate(
            Number(isFlipped.value),
            [0, 1],
            [0, 180],
        );
        const rotateValue = withTiming(`${spinValue}deg`, { duration });

        return {
            transform: [{ rotateY: rotateValue }],
        };
    });

    const flippedCardAnimatedStyle = useAnimatedStyle(() => {
        const spinValue = interpolate(
            Number(isFlipped.value),
            [0, 1],
            [180, 360],
        );
        const rotateValue = withTiming(`${spinValue}deg`, { duration });

        return {
            transform: [{ rotateY: rotateValue }],
        };
    });

    return (
        <XStack justifyContent="center">
            <Animated.View
                key="front"
                style={[
                    { zIndex: 1, backfaceVisibility: 'hidden' },
                    regularCardAnimatedStyle,
                ]}
            >
                {front}
            </Animated.View>
            <Animated.View
                key="back"
                style={[
                    {
                        backfaceVisibility: 'hidden',
                        position: 'absolute',
                        zIndex: 2,
                    },
                    flippedCardAnimatedStyle,
                ]}
            >
                {back}
            </Animated.View>
        </XStack>
    );
};
